import { SortDirection } from '@tanstack/react-table'
import { CgChevronDown, CgChevronUp } from 'react-icons/cg'

import { BoxProps, HStack, Text } from '@chakra-ui/react'

interface HeaderCellIProps extends BoxProps {
  label: string
  getIsSorted?: () => false | SortDirection
}

export const HeaderCell = ({
  label,
  getIsSorted,
  ...rest
}: HeaderCellIProps) => {
  return (
    <HStack
      color='#000000'
      fontSize='14px'
      fontWeight='600'
      lineHeight='18px'
      {...rest}
    >
      <Text>{label}</Text>
      {getIsSorted &&
        {
          asc: <CgChevronUp color='#000000' size='12px' />,
          desc: <CgChevronDown color='#000000' size='12px' />,
        }[getIsSorted() as string]}
    </HStack>
  )
}
